// His label formats (Z Furniture FORMATS), in millimetres — kept apart from the label engine so a
// screen can list them without loading the PDF library. The name of each format is
// "label.fmt.<key>" in the word list.
export type FormatKey = "a4" | "a4x2" | "ql62" | "dymo" | "zebra";
type Format = { w: number; h: number; big?: boolean; page?: [number, number]; slots?: [number, number][] };
export const FORMATS: Record<FormatKey, Format> = {
  a4: { w: 297, h: 210, big: true, page: [297, 210], slots: [[0, 0]] },
  a4x2: { w: 210, h: 148.5, big: true, page: [210, 297], slots: [[0, 0], [0, 148.5]] },
  ql62: { w: 100, h: 62 },
  dymo: { w: 101, h: 54 },
  zebra: { w: 100, h: 150 },
};
